export function buildYandexMapsCoordinateUrl(latitude, longitude) {
  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    return '';
  }
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return '';
  }
  if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) {
    return '';
  }

  const point = `${longitude.toFixed(6)},${latitude.toFixed(6)}`;
  const params = new URLSearchParams({
    'whatshere[point]': point,
    'whatshere[zoom]': '17',
  });
  return `https://yandex.ru/maps/?${params.toString()}`;
}

export function isYandexMapsWebUrl(value) {
  try {
    const url = new URL(value);
    return (
      url.protocol === 'https:'
      && /(^|\.)yandex\./i.test(url.hostname)
      && url.pathname.includes('/maps')
    );
  } catch {
    return false;
  }
}

export function getTravelPlaceMapsUrl(place) {
  if (isYandexMapsWebUrl(place?.sourceUrl)) {
    return place.sourceUrl;
  }
  return buildYandexMapsCoordinateUrl(place?.latitude, place?.longitude);
}
